<template>
  <v-dialog
    max-width="500px"
    v-model="isOn"
    persistent
  >
    <v-card>
      <v-card-title>
        <v-flex>
          <span>Copy invitation link</span>
          <v-layout row >
            <v-text-field
              v-model="link"
            />
            <v-btn
              fab dark  color="primary"
              v-clipboard:copy="link"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <v-icon dark>content_copy</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-card-actions>
        <v-btn
          color="primary"
          flat
          @click="closeModal"
        >
          close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'SmallModal',
    props: {
      isOn: {
        required: true,
        type: Boolean,
        default: false
      },
      link: {
        required: true,
        type: String,
        default: ''
      }
    },
    methods: {
      ...mapActions(['showResultSuccessMessage', 'showResultErrorMessage']),
      onCopy () {
        this.showResultSuccessMessage('The link was added to clipboard.')
      },
      onError () {
        this.showResultErrorMessage()
      },
      closeModal () {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .link {
    overflow-x: auto;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Invitation/modal.vue